require('/opt/odin/app/frontend/components/banner_approval_cta/index.module.scss');module.exports = "../../app/cells/components/banner_approval_cta/show.erb";